import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    model: _ctx.saihForm,
    "label-position": "top",
    ref: "form",
    rules: _ctx.rules
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, { gutter: 12 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "name",
                label: _ctx.$t('label.name')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.saihForm.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.saihForm.name) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "code",
                label: _ctx.$t('label.code')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.saihForm.code,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.saihForm.code) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "river",
                label: _ctx.$t('label.river')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.saihForm.river,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.saihForm.river) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, {
        shadow: "never",
        class: "app-form-item"
      }, {
        header: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("label.coordinates")), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "utmX",
                    label: _ctx.$t('label.utmX')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.saihForm.utmX,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.saihForm.utmX) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "utmY",
                    label: _ctx.$t('label.utmY')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.saihForm.utmY,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.saihForm.utmY) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "timeZone",
                    label: _ctx.$t('label.timeZone')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.saihForm.timeZone,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.saihForm.timeZone) = $event)),
                        min: 0,
                        step: 1,
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, {
        shadow: "never",
        class: "app-form-item"
      }, {
        header: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("label.address")), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "municipality",
                    label: _ctx.$t('label.municipality')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.saihForm.municipality,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.saihForm.municipality) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "province",
                    label: _ctx.$t('label.province')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.saihForm.province,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.saihForm.province) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "confederation",
                    label: _ctx.$t('label.confederation')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.saihForm.confederation,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.saihForm.confederation) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}